import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const SETTINGS_KEY = 'seyHot_settings';

const defaultSettings = {
  emailNotifications: true,
  smsNotifications: false,
  marketing: false,
  privacy: { tracking: false, personalization: true },
  language: 'tr',
};

export async function readSettings(auth, db) {
  const user = auth.currentUser;
  try {
    if (user) {
      const ref = doc(db, 'user_settings', user.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const s = { ...defaultSettings, ...snap.data() };
        try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(s)); } catch {}
        return { settings: s, source: 'firestore' };
      }
      // if not exists, create default in Firestore once
      await setDoc(ref, { ...defaultSettings, updatedAt: serverTimestamp() }, { merge: true });
      try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(defaultSettings)); } catch {}
      return { settings: defaultSettings, source: 'firestore' };
    }
  } catch (e) {
    console.error('readSettings firestore failed:', e);
  }
  // guest/local fallback
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) return { settings: { ...defaultSettings, ...JSON.parse(raw) }, source: 'local' };
  } catch {}
  return { settings: defaultSettings, source: 'default' };
}

export async function writeSettings(auth, db, partial) {
  const user = auth.currentUser;
  // Merge with local copy first
  let merged = defaultSettings;
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) merged = { ...merged, ...JSON.parse(raw) };
  } catch {}
  merged = { ...merged, ...partial };

  try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(merged)); } catch {}

  if (user && db) {
    try {
      await setDoc(doc(db, 'user_settings', user.uid), { ...partial, updatedAt: serverTimestamp() }, { merge: true });
    } catch (e) {
      console.error('writeSettings firestore failed:', e);
    }
  }
  return merged;
}
